import PricingBaseController from "~/controllers_back/checkout/pricing-base_controller"

export default class extends PricingBaseController {
  static targets = [
    ...PricingBaseController.targets,
    "monthlyCrossedPrice"
  ]

  updateForYearly(level) {
    // Show crossed monthly prices
    this.monthlyCrossedPriceTargets.forEach(el => el.style.display = "block")

    // Call parent implementation
    super.updateForYearly(level)
  }

  updateForMonthly(level) {
    // Hide crossed monthly prices
    this.monthlyCrossedPriceTargets.forEach(el => el.style.display = "none")

    // Call parent implementation
    super.updateForMonthly(level)
  }

  goToBilling() {
    const billingTabLink = this.element.querySelector(
      '[data-tabs-target="tabLink"][aria-controls="co-free-billing"]'
    )

    if (billingTabLink) {
      billingTabLink.click()

      // Simple retry mechanism for button enabling
      setTimeout(() => this.enableButtonWithRetry(3), 300)
    }
  }

  togglePlanDetails(event) {
    super.togglePlanDetails(event)

    // For upgrade from free, selecting a plan when viewing details
    const level = parseInt(event.currentTarget.dataset.level)
    this.selectPlan(level)
  }

  enableButtonWithRetry(retries) {
    const checkoutController = this.application.getControllerForElementAndIdentifier(
      this.element,
      "checkout"
    )

    if (checkoutController?.checkButtonState) {
      checkoutController.checkButtonState()
    } else if (retries > 0) {
      setTimeout(() => this.enableButtonWithRetry(retries - 1), 200)
    } else {
      // Direct fallback
      const payButton = document.querySelector('[data-checkout-target="payButton"]') ||
        document.querySelector('#co-free-billing button[type="button"]')
      if (payButton) {
        payButton.disabled = false
        this.updateFormFieldsDirectly(this.selectedLevelValue, this.selectedBillingValue)
      }
    }
  }
}
